import { render } from "./ManaGerView.vue?vue&type=template&id=0083c11c&scoped=true"
import script from "./ManaGerView.vue?vue&type=script&lang=js"
export * from "./ManaGerView.vue?vue&type=script&lang=js"

import "./ManaGerView.vue?vue&type=style&index=0&id=0083c11c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0083c11c"]])

export default __exports__